<template>
  <AbsPopup id="ReportList" type="alert" title="신고사유" @close="$emit('close')" @submit="submit">
    <template #body>
      <div class="popup-body">
        <ul>
          <li>
            <span>날짜</span>
          </li>
          <li>
            <span>내용</span>
          </li>
          <li>
            <span>신고자</span>
          </li>
          <li>
          </li>
        </ul>
        <ul v-for="(item, index) in list" :key="index">
          <li>
            <span>{{ timeToDateString(item.date) }}</span>
          </li>
          <li>
            <span>{{ item.comment }}</span>
          </li>
          <li>
            <span>{{ item.userNic }}</span>
          </li>
          <li>
            <input type="checkbox" :id="'lie' + index" @change="lieClick(item)" :checked="item.lie"/>
            <label :for="'lie' + index">허위</label>
          </li>
        </ul>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import {timeToDateString} from '@/components/js/Utils'

export default {
  props: {
    option: {
      type: Object
    }
  },
  watch: {
  },
  created () {
  },
  mounted () {
    if (this.option.param) {
      console.log(this.option.param)
      this.list = this.option.param.report
      this.$emit('loading', false)
    }
  },
  data () {
    return {
      timeToDateString: timeToDateString,
      list: null
    }
  },
  name: 'ReportList',
  computed: {
  },
  methods: {
    lieClick (item) {
      console.log(item)
      this.$http.post('/api/admin/cs/lie', {id: item._id, lie: !item.lie}).then((row) => {
        console.log(row)
        if (row.success) {
          item.lie = !item.lie
        } else {
        }
      })
    },
    submit () {
      this.$emit('close')
    }
  },
  components: {
    AbsPopup
  }
}
</script>

<style scoped>
#ReportList {
  padding: 10px 0;
  width: 600px;
}
.popup-body {
  display: flex;
  flex-direction: column;
  padding: 10px;
  width: 100%;
  min-height: 300px;
}
.popup-body > ul {
  display: flex;
  flex-direction: row;
  list-style: none;
  line-height: 40px;
  align-items: center;
  border-bottom: 1px solid var(--line-guide);
}
.popup-body > ul > li {
  display: flex;
}
.popup-body > ul > li:nth-child(1) {
  width: 100px;
  justify-content: center;
  /* flex: 1; */
}
.popup-body > ul > li:nth-child(2) {
  flex: 1;
}
.popup-body > ul > li:nth-child(3) {
  width: 100px;
  justify-content: center;
}
.popup-body > ul > li:nth-child(4) {
  width: 100px;
  justify-content: center;
  align-items: center;
}
.popup-body > ul input:checked + label {
  color: var(--active);
}
.popup-body > ul > li:last-child {
  margin-left: auto;
  color: var(--text-base);
}
</style>



// WEBPACK FOOTER //
// src/components/popup/admin/ReportList.vue